import { render, staticRenderFns } from "./takeAnExam.vue?vue&type=template&id=7994e767&scoped=true"
import script from "./takeAnExam.vue?vue&type=script&lang=js"
export * from "./takeAnExam.vue?vue&type=script&lang=js"
import style0 from "./takeAnExam.vue?vue&type=style&index=0&id=7994e767&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7994e767",
  null
  
)

export default component.exports